const ABOUT_IMG = "https://images.pexels.com/photos/10469305/pexels-photo-10469305.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="py-24 md:py-36 bg-melissa-bg2 relative">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-16 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <div className="relative aspect-[4/5] overflow-hidden">
            <img
              src={ABOUT_IMG}
              alt="Melissa working with a client"
              data-testid="about-image"
              className="absolute inset-0 w-full h-full object-cover"
            />
          </div>
        </div>
        <div className="lg:col-span-7 order-1 lg:order-2">
          <p className="text-xs uppercase tracking-overline text-melissa-rose mb-6">
            01 — About Melissa
          </p>
          <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl text-melissa-ink leading-tight tracking-tight">
            I believe makeup should feel <em className="italic text-melissa-rose">like you</em> —
            only quieter, brighter, more you.
          </h2>
          <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-8 text-melissa-inkSoft font-light leading-relaxed">
            <p>
              Born in Orange, CA and trained between Los Angeles and New York, I've spent
              the last twelve years studying skin: how it catches light, how it ages, how it
              holds memory. Every face is a small landscape, and my work begins with looking.
            </p>
            <p>
              From private bridal suites to international editorial sets, my approach stays
              the same — calm, slow, considered. I work with clean luxury brands, prep skin
              like a facialist, and finish with the lightest hand I can manage.
            </p>
          </div>
          <div className="mt-12 grid grid-cols-2 md:grid-cols-3 gap-8">
            {[
              ["Trained in", "NYC · LA"],
              ["Specialty", "Bridal · Editorial"],
              ["Press", "Brides"],
            ].map(([k, v]) => (
              <div key={k}>
                <div className="text-[10px] uppercase tracking-overline text-melissa-inkSoft mb-2">{k}</div>
                <div className="font-serif text-xl text-melissa-ink">{v}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
